export class AuthUserModel {
  name!: string;

  username!: string;

  token!: string;

  permissions!: number;
}
